export const FACET_NAME_PREFIX = 'facets_'
